import React, { useEffect, useState } from 'react';
import { cooperplaceApi } from 'services/api';
import { BlacklistProvider } from './context';
import { useParams } from 'react-router-dom';
import { BlacklistItemDetails as Details } from './Pages/Details';
import { BlacklistRegister as Register } from './Pages/Register';
import { useSnackbar } from 'v3/components/Snackbar';
import { fetchBlacklistTypes } from 'utils/fetches';
import { useNavigate } from 'react-router-dom';
import { useValidation } from 'hooks';
import { dataSchema, dataSchemaUpdate } from './validator';
import { useModal } from 'hooks';

import Text from 'v3/components/Text';

export default function BlackList() {
  const params = useParams()
  const snackbar = useSnackbar();
  const navigate = useNavigate();
  const editBlacklistModal = useModal();

  const [blacklist, setBlacklist] = useState(null);
  const [blacklistType, setBlacklistType] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setErrors] = useState({});
  const [data, setData] = useState({
    blacklistType: null,
    person: null,
    vehicle: null,
    wagon: null,
    reason: null,
    description: null,
    files: [],
  });

  const [errorsCreated, { validate: validateCreated }] = useValidation(
    dataSchema
  );

  const [errorsUpdated, { validate: validateUpdated }] = useValidation(
    dataSchemaUpdate
  );

  function showSnackbar(text, options) {
    snackbar.show(<Text>{text}</Text>, options);
  }

  async function fetchBlackList() {
    setLoading(true);
    try {
      const { data } = await cooperplaceApi.get(`blacklist/${params.id}`);
      setBlacklist(data)
    } catch (err) {

      showSnackbar('Não foi possível carregar o item da blacklist', {
        type: 'error',
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }

  async function registerBlacklist(data) {
    setLoading(true);

    const formatPayload = {
      blacklistType: data.blacklistType?.slug,
      personId: data?.person ? data?.person?.id : null,
      vehicleId: data?.vehicle ? data?.vehicle?.id : null,
      wagonId: data?.wagon ? data?.wagon?.id : null,
      reason: data.reason,
      description: data.description
    };

    const formData = new FormData();

    data.files.forEach((file, index) => {
      const name = `${Date.now()}${index}.${file.file.type.split('/')[1]}`;
      const newFile = new File([file.file.blob], name, {
        type: file.file.type,
      });
      formData.append('file', newFile);
    });


    formData.append('blacklistType', formatPayload.blacklistType)
    if (formatPayload.personId) {
      formData.append('personId', formatPayload.personId);
    }
    if (formatPayload.vehicleId) {
      formData.append('vehicleId', formatPayload.vehicleId);
    }
    if (formatPayload.wagonId) {
      formData.append('wagonId', formatPayload.wagonId);
    }

    formData.append('reason', formatPayload.reason)
    formData.append('description', formatPayload.description)

    try {

      const [isValid] = await validateCreated({
        blacklistType: data.blacklistType?.slug,
        personId: data?.person?.id,
        vehicleId: data?.vehicle?.id,
        wagonId: data?.wagon?.id,
        reason: data.reason,
        description: data.description,
      });

      if (!isValid) {
        snackbar.show(<Text>Verifique os campos obrigatórios</Text>, {
          type: 'error',
        });
        setLoading(false);
        return;
      }

      await cooperplaceApi.post('blacklist', formData);

      showSnackbar('Blacklist cadastrada com sucesso!', {
        type: 'success',
      });

      navigate('/blacklist');

      setErrors({});
      setData({})

    } catch (err) {
      const message = err?.response?.data?.error;
      showSnackbar(message, {
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  }

  async function updateBlacklist(data) {

    const formData = new FormData();

    data.files.forEach((file, index) => {
      const name = `${Date.now()}${index}.${file.file.type.split('/')[1]}`;
      const newFile = new File([file.file.blob], name, {
        type: file.file.type,
      });
      formData.append('file', newFile);
    });

    formData.append('reason', data.reason)
    formData.append('description', data.description)
    formData.append('active', data.active);


    try {
      setLoading(true);

      const [isValid] = await validateUpdated({
        reason: data.reason,
        description: data.description,
      });

      if (!isValid) {
        snackbar.show(<Text>Verifique os campos obrigatórios</Text>, {
          type: 'error',
        });
        setLoading(false);
        return;
      }

      await cooperplaceApi.put(`blacklist/${params.id}`, formData);

      showSnackbar('Blacklist atualizada com sucesso!', {
        type: 'success',
      });

      fetchBlackList()

      editBlacklistModal.close();

      setErrors({});
      setData({})

    } catch (err) {
      setLoading(false);
      const message = err?.response?.data?.error;
      showSnackbar(message, {
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  }


  useEffect(() => {
    if (params.id) {
      fetchBlackList();
    }
    fetchBlacklistTypes().then(setBlacklistType)
  }, [params.id]);

  useEffect(() => {
    setErrors(errorsCreated)
  }, [errorsCreated]);

  useEffect(() => {
    setErrors(errorsUpdated)
  }, [errorsUpdated]);

  return (
    <BlacklistProvider
      value={{
        editBlacklistModal,
        blacklist,
        showSnackbar,
        loading,
        registerBlacklist,
        updateBlacklist,
        setData,
        data,
        blacklistType,
        error,
        setErrors
      }}
    >
      {params.id ? <Details /> : <Register />}
    </BlacklistProvider>
  )
}


